var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'rollingDots')?_c('div',{class:_vm.$style.rollingDots},[_c('div',{class:_vm.$style.firstDot,style:({ 'background-color': _vm.color })}),_c('div',{class:_vm.$style.secondDot,style:({ 'background-color': _vm.color })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }